import { render, staticRenderFns } from "./ChatPage.vue?vue&type=template&id=a8dce584&lang=pug&"
import script from "./ChatPage.ts?vue&type=script&lang=js&"
export * from "./ChatPage.ts?vue&type=script&lang=js&"
import style0 from "./ChatPage.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports